import { ShieldCheck } from "lucide-react";
import {
  ContainmentPlanParamsSchema,
  defaultContainmentPlanParams,
  type ContainmentPlanParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { WidgetDef } from "../types.js";
import {
  ContainmentPlanWidget,
  CONTAINMENT_VISIBLE_LIMIT,
} from "./Component.js";
import { shortDate } from "./presentation.js";
import { ContainmentPlanExpandedEditor } from "./ExpandedEditor.js";

export const containmentPlanDef: WidgetDef<ContainmentPlanParams> = {
  kind: "containmentPlan",
  label: "Containment Action Plan",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 752, h: 384 },
  defaultParams: defaultContainmentPlanParams,
  Component: ContainmentPlanWidget,
  ExpandedComponent: ContainmentPlanExpandedEditor,
  storage: "sql",
  schema: ContainmentPlanParamsSchema,
  accent: "amber",
  icon: ShieldCheck,
  subtitle: "Plug every leak — own it, work it, judge it",
  defaultRoster: true,
  category: "multi",
  layout: { col: "full", row: 2, width: 752, height: 360 },
  expandable: true,
  renderFooter: (data) => ({
    left: `Showing ${Math.min(CONTAINMENT_VISIBLE_LIMIT, data.actions.length)} of ${data.actions.length} · Expand to view all`,
    right: data.nextReviewDate
      ? `Next review ${shortDate(data.nextReviewDate)}`
      : "Next review not set",
  }),
};

registerWidget(containmentPlanDef);
